<template>
  <div>
    <el-form :inline="true" :model="{}">
      <el-form-item :label="activeInfo.day_hour.name">
        <el-input v-model="activeInfo.day_hour.val" v-enterNumberPoint2 style="width: 52px"></el-input>
        <span style="color: rgba(0, 0, 0, 0.85); margin-left: 3px">{{ $t('1523') }}</span>
      </el-form-item>
    </el-form>
    <el-collapse v-model="activeNames">
      <el-collapse-item v-for="(val, index) in tableData" :key="index" :name="index">
        <template slot="title">
          {{ val.txt }}
          <el-tooltip class="item" effect="dark" :content="val.ctx_txt" placement="top-start">
            <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
          </el-tooltip>
          <span class="tip">{{ activeNames.includes(index) ? $t('payroll_salary_13') : $t('payroll_salary_12') }}</span>
        </template>
        <el-table
          class="table"
          :data="val.columns"
          @selection-change="tableSelectHandle(index, $event)"
          :ref="'table' + index"
        >
          <el-table-column type="selection" width="65"> </el-table-column>
          <template v-for="clo in activeData.clo[index]">
            <template v-if="clo.type === 'input'">
              <el-table-column
                :fixed="clo.fixed"
                :key="clo.label"
                :label="$t(clo.label)"
                :prop="clo.prop"
                :min-width="clo.width"
              >
                <template slot-scope="scope">
                  <template v-if="scope.row.is_input === '1'">
                    <el-form :model="scope.row" v-if="index === 1 && hourWeekday[scope.row.id]" ref="formInput">
                      <el-form-item
                        class="content"
                        prop="val"
                        :hide-required-asterisk="true"
                        :rules="[{ required: !hourWeekday[scope.row.id].val, message: $t('1593'), trigger: 'blur' }]"
                      >
                        <el-input
                          v-model="scope.row.val"
                          v-enterNumberPoint2
                          v-enterNumberMax="100000"
                          size="small"
                        ></el-input>
                        <span>{{ scope.row.val_unit }}</span>
                      </el-form-item>
                    </el-form>
                    <template v-else>
                      <el-input
                        v-model="scope.row.val"
                        v-enterNumberPoint2
                        v-enterNumberMax="100000"
                        size="small"
                      ></el-input>
                      <span>{{ scope.row.val_unit }}</span>
                    </template>
                  </template>
                  <span v-else>{{ scope.row[clo.prop] }}</span>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column
                :fixed="clo.fixed"
                :key="clo.label"
                :label="$t(clo.label)"
                :prop="clo.prop"
                :min-width="clo.width"
              ></el-table-column>
            </template>
          </template>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <div class="wrap-con" v-if="$route.query.type === '1'">
      <h1 class="clearfix">
        <i class="el-icon-warning"></i>
        <span
          >{{ $t('i18n.919509c0212347de859d4f2288a191b8') }}: {{ $t('i18n.2bd06c5eb9d4442881f8ad843c2b0bc9') }}</span
        >
      </h1>
      <el-collapse v-model="activeNames2">
        <!-- 周期内有入职，无离职 -->
        <el-collapse-item :title="$t('i18n.6b3472844c91420d9892085f0c11071b')" :name="0">
          <template slot="title">
            <div>
              <span>{{ $t('i18n.6b3472844c91420d9892085f0c11071b') }}</span>
              <span class="tip">{{
                activeNames2.includes(0) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <div class="salary-box">
            <el-button type="text" @click="checkExample('1')">{{
              $t('i18n.d7f42cdf6b274ccb8001286ce2ca250c')
            }}</el-button>
            <el-radio-group
              v-model="activeInfo.extend.cycle_hire_no_leave.type"
              @change="handleGroup('cycle_hire_no_leave')"
              class="extend salary-con"
            >
              <el-radio :label="1">{{ $t('i18n.afdfff977ffb44d482f0ce31ea2e29f5') }}</el-radio>
              <el-radio :label="2">{{ $t('i18n.f08810fe0bb24376852ccc105c863834') }}</el-radio>
              <el-radio :label="3">{{ $t('pay_slip_46') }}</el-radio>
              <div class="salary-con-sub">
                <p>
                  {{ $t('i18n.271578b3c2394cc4a66a7579c7e96b2d') }}
                  <el-select
                    :disabled="activeInfo.extend.cycle_hire_no_leave.type !== 3"
                    v-model="activeInfo.extend.cycle_hire_no_leave.before"
                    :placeholder="$t('221')"
                    size="small"
                  >
                    <el-option :label="$t('i18n.c8b2452f4b3f4d52bb146918cc0010eb')" :value="1" />
                    <el-option :label="$t('i18n.1006d16a63f44b609d5a99fc3626f980')" :value="2" />
                  </el-select>
                </p>
                <p>
                  {{ $t('i18n.670521552dda403e9483bc3c8ed6be42') }}
                  <el-select
                    :disabled="activeInfo.extend.cycle_hire_no_leave.type !== 3"
                    v-model="activeInfo.extend.cycle_hire_no_leave.after"
                    :placeholder="$t('221')"
                    size="small"
                  >
                    <el-option :label="$t('i18n.c8b2452f4b3f4d52bb146918cc0010eb')" :value="1" />
                    <el-option :label="$t('i18n.1006d16a63f44b609d5a99fc3626f980')" :value="2" />
                  </el-select>
                </p>
              </div>
            </el-radio-group>
          </div>
        </el-collapse-item>
        <!-- 周期内无入职，有离职 -->
        <el-collapse-item :title="$t('i18n.1c06b5f9592c453686a7d0768adaef64')" :name="1">
          <template slot="title">
            <div>
              <span>{{ $t('i18n.1c06b5f9592c453686a7d0768adaef64') }}</span>
              <span class="tip">{{
                activeNames2.includes(1) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <div class="salary-box">
            <el-button type="text" @click="checkExample('2')">{{
              $t('i18n.d7f42cdf6b274ccb8001286ce2ca250c')
            }}</el-button>
            <el-radio-group
              v-model="activeInfo.extend.cycle_no_hire_leave.type"
              @change="handleGroup('cycle_no_hire_leave')"
              class="extend salary-con"
            >
              <el-radio :label="1">{{ $t('i18n.afdfff977ffb44d482f0ce31ea2e29f5') }}</el-radio>
              <el-radio :label="2">{{ $t('i18n.02e7643f25ea4168baaeadbd84ef7859') }}</el-radio>
              <el-radio :label="3">{{ $t('pay_slip_46') }}</el-radio>
              <div class="salary-con-sub">
                <p>
                  {{ $t('i18n.cbba8ec1cd7f449b99397393236673c7') }}
                  <el-select
                    :disabled="activeInfo.extend.cycle_no_hire_leave.type !== 3"
                    v-model="activeInfo.extend.cycle_no_hire_leave.before"
                    :placeholder="$t('221')"
                    size="small"
                  >
                    <el-option :label="$t('i18n.c8b2452f4b3f4d52bb146918cc0010eb')" :value="1" />
                    <el-option :label="$t('i18n.1006d16a63f44b609d5a99fc3626f980')" :value="2" />
                  </el-select>
                </p>
                <p>
                  {{ $t('i18n.4b161275513249d7b350f0aa994bbf3f') }}
                  <el-select
                    :disabled="activeInfo.extend.cycle_no_hire_leave.type !== 3"
                    v-model="activeInfo.extend.cycle_no_hire_leave.after"
                    :placeholder="$t('221')"
                    size="small"
                  >
                    <el-option :label="$t('i18n.c8b2452f4b3f4d52bb146918cc0010eb')" :value="1" />
                    <el-option :label="$t('i18n.81638fcb82a8434db1f8798313982093')" :value="2" />
                  </el-select>
                </p>
              </div>
            </el-radio-group>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <example ref="example" />
  </div>
</template>

<script>
import './directive'
import example from '../components/example'
import { get_attendance, save_attendance } from 'api/payroll/salary-scheme/detail'

export default {
  components: { example },
  props: {
    activeObj: {
      type: Object
    }
  },
  data() {
    return {
      tableData: {},
      activeNames: [0],
      activeNames2: [0, 1],
      activeData: this.activeObj.data,
      activeInfo: this.activeObj.data.info,
      cActiveInfo: this.activeObj.data.cInfo, // 拷贝数据，判断是否修改
      hourWeekday: {}
    }
  },
  mounted() {
    this.activeInfo.selectTable = {}
    this.activeInfo.day_hour = {}
    this.getAttendance()
  },
  methods: {
    getAttendance() {
      get_attendance({ payroll_sub_project_scheme_id: this.$route.params.id }).then(res => {
        if (res && res.code === 1) {
          this.activeInfo.day_hour = res.data.day_hour // day_hour
          this.activeInfo.extend = { ...this.activeInfo.extend, ...res.data.extend } // extend
          this.tableData = res.data.list // 表格
          // 拷贝初始数据
          this.cActiveInfo.day_hour = JSON.parse(JSON.stringify(res.data.day_hour || {}))
          this.cActiveInfo.extend = JSON.parse(JSON.stringify(res.data.extend || {}))
          this.$nextTick(() => {
            this.activeNames = []
            const cSelectTable = {}
            this.tableData.forEach((collapseItem, index) => {
              cSelectTable[index] = []
              // 手风琴默认全部打开
              this.activeNames.push(index)
              collapseItem.columns.forEach(v => {
                if (v.is_select === '1') {
                  cSelectTable[index].push(v)
                  // 表格选中数据
                  this.$refs['table' + index][0].toggleRowSelection(v, true)
                }
              })

              if (!cSelectTable[index].length) delete cSelectTable[index]
            })
            // 拷贝初始数据
            this.cActiveInfo.selectTable = JSON.parse(JSON.stringify(cSelectTable))
          })
        }
      })
    },
    tableSelectHandle(key, arr) {
      // 表格选中数据
      this.activeInfo.selectTable[key] = arr
      if (key === 1) {
        this.hourWeekday = {}
        arr.forEach(item => {
          this.$set(this.hourWeekday, item.id, item)
        })
      }
    },
    saveData() {
      const res = Object.values(this.activeInfo.selectTable).flat(1)
      const state = res.some(item => {
        if (Number(item.type) === 3) {
          return !item.val
        }
      })
      // 考勤异常为设置添加项 提示 请设置扣款金额
      if (state) {
        this.$message.warning(this.$t('payroll_salary_49'))
        return
      }
      if (this.$refs.formInput) {
        const validBase = []
        this.$refs.formInput.forEach(item => {
          return item.validate(async valid => {
            validBase.push(valid)
          })
        })
        if (validBase.includes(false)) {
          this.$message({
            message: this.$t('payroll_salary_5'),
            type: 'warning'
          })
          return false
        }
      }
      const { cycle_hire_no_leave, cycle_no_hire_leave } = this.activeInfo.extend
      if (Number(cycle_hire_no_leave.type) === 3 && !cycle_hire_no_leave.before && !cycle_hire_no_leave.after) {
        this.$message.warning(this.$t('i18n.cc9c0ad2c58844f3b648b81a638b900c'))
        return
      }
      if (Number(cycle_no_hire_leave.type) === 3 && !cycle_no_hire_leave.before && !cycle_no_hire_leave.after) {
        this.$message.warning(this.$t('i18n.09935717587f42dc86afa77de80f1404'))
        return
      }
      return save_attendance({
        payroll_sub_project_scheme_id: this.$route.params.id,
        items: [
          {
            id: this.activeInfo.day_hour.id,
            val: this.activeInfo.day_hour.val,
            type: this.activeInfo.day_hour.type
          },
          ...res.map(v => ({
            id: v.id,
            val: v.val,
            type: v.type
          }))
        ],
        extend: this.activeInfo.extend
      })
    },
    handleGroup(val) {
      this.$set(this.activeInfo.extend[val], 'after', '')
      this.$set(this.activeInfo.extend[val], 'before', '')
    },
    checkExample(type) {
      this.$refs.example.init(type)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0px;
}
.wrap-con {
  .clearfix {
    font-size: 14px;
    color: #8c8c8c;
    font-weight: normal;
    padding-bottom: 12px;
    .el-icon-warning {
      font-size: 16px;
      color: #5D51DA;
      margin-right: 4px;
    }
  }
  &:first-child {
    border-bottom: 1px dashed #d9d9d9;
  }
}
.salary-box {
  padding-top: 5px;
  .salary-tip {
    font-size: 14px;
    padding-bottom: 5px;
  }
  .salary-con {
    padding-left: 20px;
    display: block;
    .el-radio {
      display: block;
      padding-bottom: 10px;
    }
    &-sub {
      padding-left: 20px;
      font-size: 14px;
      p {
        padding-bottom: 5px;
      }
    }
  }
}
.table {
  margin-top: 24px;
}
.el-input {
  max-width: 52px;
  /deep/ .el-input__inner {
    width: 100%;
    padding: 0 8px;
  }
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -3px;
  margin-left: 5px;
}
</style>
